import React, { useState, useEffect, useRef } from "react";
import { FaInstagram, FaViber } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import discBrakes from '../components/layout/assets/discbrakes.png'

function Brakes() {

    const testimonials = [
        { text: "Ми помогнаа да изберам најдобро за моето возило.", name: "Марија, Битола" },
        { text: "Дисковите стигнаа за само 2 часа. Одлична услуга!", name: "Александар Милановски, Скопје" },
        { text: "Ми препорачаа плочки од Brembo и сум презадоволен.", name: "Игор Петричевиќ, Куманово" },
        { text: "Најдов делови кои никаде ги немаше. Браво!", name: "Викторија Стеваноска, Прилеп" },
        { text: "Комуникацијата преку Viber беше брза и јасна.", name: "Никола Наков, Струмица" },
        { text: "Не се разбирам многу, ама ми објаснија се и ми помогнаа да нарачам.", name: "Аце, Велес" },
        { text: "Цените им се подобри од многу продавници низ градот.", name: "Гоце, Тетово" },
        { text: "Купив плочки за Audi А1 по супер цена.", name: "Јована, Штип" },
        { text: "Ми стигнаа деловите за 1 ден. Топ услуга!", name: "Милош, Кочани" },
        { text: "Многу професионални. Ми понудија неколку опции според буџетот.", name: "Бобан Мекиновски, Охрид" },
        { text: "Нарачав дискови за VW Passat – се вклопија совршено.", name: "Даниел, Гевгелија" },
        { text: "Конечно продавница што не те замара – кажуваш што возиш и добиваш се!", name: "Роберт, Делчево" },
        { text: "Ми најдоа дел за редок модел на кола. И тоа оригинал!", name: "Елена, Кавадарци" },
        { text: "Брзо, коректно и без непотребно одолговлекување. Деловите ми стигнаа за 3 часа од нарачката", name: "Филип Трајковски, Скопје" },
        { text: "Многу лесно се договоривме преку Instagram. Им кажав што возам и ми пратија се што ми беше потребно. Препорачувам!", name: "Кристина, Битола" },
        { text: "Одлична комуникација и брза испорака!", name: "Антонио, Ресен" },
        { text: "Ми пратија неколку предлози и помогнаа да изберам според стил на возење.", name: "Африм, Струга" },
        { text: "Секогаш достапни и љубезни. Веќе не барам делови на друго место.", name: "Тони Јовановски, Крива Паланка" },
        { text: "Нарачав повеќе делови и добив попуст без да прашам – фер и поштено!", name: "Валентин, Радовиш" },
        { text: "Ми дадоа и совет за монтажа. Не очекував толку внимание.", name: "Жарко, Свети Николе" }
    ];

    const pageTitle = `Дискови и плочки за автомобили`;
    const pageDescription = `Побарајте понуда на дискови, плочки и гуртни за вашиот автомобил.`;
    const pageKeywords = `дискови, плочки, систем за кочење, кочници, гуртни, diskovi, kocnici, gurtni, plocki`;


    const gap = 24; // px

    const [visibleCards, setVisibleCards] = useState(3);
    const [cardWidth, setCardWidth] = useState(320);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(true);

    const extendedTestimonials = [...testimonials, ...testimonials.slice(0, visibleCards)];

    const API_URL = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        name: "",
        brend: "",
        model: "",
        kw: "",
        year: "",
        vinNumber: "",
        phoneOrEmail: "",
        comment: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(`${API_URL}/email/discBrakesForm`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',  // Specify the content type
                },
                body: JSON.stringify(formData),
            })

            const result = await response.json()

            if (result.data === true) {
                toast.success(`Успешно го испративте вашето барање. Ви благодариме!`);
                setFormData({
                    name: "",
                    brend: "",
                    model: "",
                    kw: "",
                    year: "",
                    vinNumber: "",
                    phoneOrEmail: "",
                    comment: "",
                })
                setLoading(false);
            }
            else {
                setLoading(false);
                toast.warning(`Настана проблем при испраќањето на барањето. Ве молиме пишете ни на 074 22 95 95.`);
            }

        } catch (error) {
            toast.warning(`Настана проблем при испраќањето на барањето. Ве молиме пишете ни на 074 22 95 95.`);
        }
    };

    useEffect(() => {
        function updateSize() {
            const width = window.innerWidth;

            if (width < 640) {
                setVisibleCards(1);
                setCardWidth(width - 32); // padding-left + right 16px + 16px
            } else if (width < 1024) {
                setVisibleCards(2);
                setCardWidth((width - gap * (2 - 1) - 32) / 2); // 32 for padding px-4 *2
            } else {
                setVisibleCards(3);
                setCardWidth(320);
            }
        }

        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    useEffect(() => {
        setCurrentIndex(0);
    }, [visibleCards]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => prev + 1);
            setIsTransitioning(true);
        }, 5000);
        return () => clearInterval(interval);
    }, [visibleCards]);

    useEffect(() => {
        if (currentIndex === testimonials.length) {
            const timeout = setTimeout(() => {
                setIsTransitioning(false);
                setCurrentIndex(0);
            }, 700);
            return () => clearTimeout(timeout);
        } else {
            setIsTransitioning(true);
        }
    }, [currentIndex]);

    const containerWidth = cardWidth * visibleCards + gap * (visibleCards - 1);

    return (
        <div>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <meta name="keywords" content={pageKeywords} />
            </Helmet>
            <div>
                <section className="relative text-center pt-16 px-2 md:px-8">
                    <div className="absolute inset-0 bg-gradient-to-b from-[#6bafff33] to-transparent z-0 pointer-events-none" />
                    <div className="relative z-10">
                        <h1 className="text-2xl md:text-5xl font-bold mb-4 leading-tight text-[#132532]">
                            Дискови и плочки за сите модели на автомобили
                        </h1>

                        <img
                            src={discBrakes}
                            alt="Слика од дискови и плочки"
                            className="rounded-md mx-auto py-8"
                        />

                        <p className="text-lg md:text-xl mb-8 text-[#1b2f3dcc]">
                            Нудиме квалитетни делови за системот за кочење по одлични цени. <br /> <br /> Пиши ни на <a
                                href="https://www.instagram.com/malservis.mk/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm text-white border-none gap-2 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 hover:brightness-110"
                            >
                                <FaInstagram />Instagram
                            </a> <a
                                href="viber://chat?number=%2B38974229595"
                                className="btn btn-sm text-white border-none gap-2 bg-[#665CAC] hover:bg-[#7a6dd1]"
                            >
                                <FaViber /> Viber
                            </a> или на <a href="#kontakt-forma" className="text-orange-600 underline">контакт формата</a>  подолу за персонализирана понуда. Враќаме во најкраток можен рок.
                        </p>
                    </div>
                </section>
                <section className="px-4 md:px-8">
                    <h2 className="text-3xl font-bold text-center mb-12">Како да нарачаш?</h2>
                    <div className="grid md:grid-cols-3 gap-10 text-center">
                        {[1, 2, 3].map((num) => (
                            <div key={num} className="bg-white border border-gray-200 p-6 rounded shadow-sm">
                                <div className="text-5xl font-bold text-[#F85A02] mb-4">{num}</div>
                                <p>
                                    {num === 1 ? (
                                        <>
                                            Пиши ни марка, модел, година и број на шасија од твојот автомобил и за што си заинтересиран. <br />
                                            <span className='text-red-600 mt-6'>*Пример: Предни дискови и плочки за Opel Astra H 1.7 CDTI 74 KW 2007 , бр. на шасија W0l0AHL48C5098494</span>
                                        </>
                                    ) : num === 2 ? (
                                        "Ние ти праќаме понуда со цени."
                                    ) : (
                                        "Ти нарачуваш и добиваш брза и сигурна достава до дома! Времето на достава е најчесто за 1 ден"
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>
                </section>
                <section className="py-16 px-4 md:px-8">
                    <h2 className="text-3xl font-bold text-center mb-12">Зошто да не одбереш нас?</h2>

                    <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
                        {[
                            "Оригинални делови",
                            "Работиме со проверени брендови: Brembo, Textar, ATE, Ferodo...",
                            "Брза достава низ цела Македонија",
                            "Консултација со стручно лице",
                        ].map((text, index) => (
                            <div
                                key={index}
                                className="grid grid-cols-[24px_1fr] items-start gap-3"
                            >
                                <FaCheckCircle className="text-[#F85A02] w-6 h-6" />
                                <span className="text-lg">{text}</span>
                            </div>
                        ))}
                    </div>
                </section>
                <section className="py-8 px-4 md:px-8" id="kontakt-forma">
                    <h2 className="text-3xl font-bold text-center mb-8">Побарај понуда</h2>
                    {/* <form className="max-w-2xl mx-auto grid gap-4">
                        {[
                            "Име",
                            "Марка на автомобил - Пример: Opel",
                            "Модел - Пример: Astra H 1.7 CDTI",
                            "KW",
                            "Година на производство",
                            "Број на шасија",
                            "Телефон или Email",
                        ].map((placeholder, i) => (
                            <input
                                key={i}
                                type="text"
                                placeholder={placeholder}
                                className="input input-bordered w-full bg-white text-[#132532] placeholder-gray-500"
                                required
                                disabled={loading}
                            />
                        ))}
                        <button type="submit" className="btn bg-[#F85A02] hover:bg-orange-600 text-white border-none w-full">
                            Испрати
                        </button>
                        <p className="text-red-500">*Ве молиме проверувајте и Junk/Spam папка на вашиот емаил доколку оставите емаил за комуникација.</p>
                    </form> */}
                    <form onSubmit={handleSubmit} className="max-w-2xl mx-auto grid gap-4">
                        <div>
                            <label
                                htmlFor="name"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Име
                            </label>
                            <input
                                type="name"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                                placeholder="Име"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="phoneOrEmail"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Телефонски број или Емаил
                            </label>
                            <input
                                type="text"
                                id="phoneOrEmail"
                                name="phoneOrEmail"
                                value={formData.phoneOrEmail}
                                onChange={handleChange}
                                className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                                placeholder="Телефонски број или Емаил"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="subject"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Марка
                            </label>
                            <input
                                type="text"
                                id="brend"
                                name="brend"
                                value={formData.brend}
                                onChange={handleChange}
                                className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                                placeholder="Марка на автомобилот"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="model"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Модел
                            </label>
                            <input
                                type="text"
                                id="model"
                                name="model"
                                value={formData.model}
                                onChange={handleChange}
                                className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                                placeholder="Модел на автомобилот"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="kw"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Киловати
                            </label>
                            <input
                                type="text"
                                id="kw"
                                name="kw"
                                value={formData.kw}
                                onChange={handleChange}
                                className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                                placeholder="KW"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="year"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Година на производство
                            </label>
                            <input
                                type="text"
                                id="year"
                                name="year"
                                value={formData.year}
                                onChange={handleChange}
                                className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                                placeholder="Година"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="vinNumber"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Број на шасија
                            </label>
                            <input
                                type="text"
                                id="vinNumber"
                                name="vinNumber"
                                value={formData.vinNumber}
                                onChange={handleChange}
                                className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                                placeholder="Број на шасија"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div className="sm:col-span-2">
                            <label
                                htmlFor="comment"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
                            >
                                Оставете порака
                            </label>
                            <textarea
                                id="comment"
                                name="comment"
                                value={formData.comment}
                                onChange={handleChange}
                                rows="6"
                                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                placeholder="Напишете коментар за што сте заинтересирани - Пример: предни и задни дискови и плочки."
                                required
                                disabled={loading}
                            ></textarea>
                        </div>
                        <div className="sm:col-span-2 mx-auto">
                            <button
                                type="submit"
                                className="btn btn-secondary py-3 px-5 w-[200px]"
                                disabled={loading}
                            >
                                Испрати
                            </button>
                        </div>
                        <div className="sm:col-span-2">
                            <p className="text-red-500">*Ве молиме проверувајте и Junk/Spam папка на вашиот емаил доколку оставите емаил за комуникација.</p>
                        </div>
                    </form>
                </section>
                {/* <section className="py-16 px-4 md:px-8 max-w-[1000px] mx-auto box-border">
                    <h2 className="text-3xl font-bold text-center mb-12">Што велат нашите клиенти</h2>

                    <div
                        className="overflow-hidden mx-auto"
                        style={{ width: `${containerWidth}px`, maxWidth: "100%" }}
                    >
                        <div
                            className="flex"
                            style={{
                                width: `${(cardWidth + gap) * extendedTestimonials.length - gap}px`,
                                gap: `${gap}px`,
                                transform: `translateX(-${currentIndex * (cardWidth + gap)}px)`,
                                transition: isTransitioning ? "transform 0.7s ease-in-out" : "none",
                            }}
                        >
                            {extendedTestimonials.map((item, i) => (
                                <div
                                    key={`${item.name}-${i}`}
                                    className="bg-white p-6 rounded shadow border border-gray-200 text-center flex-shrink-0"
                                    style={{ width: `${cardWidth}px`, maxWidth: "100%" }}
                                >
                                    <p className="italic text-[#1b2f3d]">„{item.text}“</p>
                                    <p className="mt-4 font-bold text-[#132532]">{item.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section> */}
            </div>
        </div>
    )
}

export default Brakes
